var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 702,
    height: 1133,
    viewBox: "0 0 702 1133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_263_49)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.621 545.259C338.287 504.689 358.116 468.101 382.649 435.582C410.17 399.102 440.787 362.445 483.92 347.357C529.558 331.392 583.528 327.346 625.997 350.456C667.391 372.981 673.905 428.438 702.189 466.132C730.668 504.085 790.913 524.962 792.528 572.384C794.152 620.095 735.806 645.673 709.662 685.617C686.149 721.541 686.766 779.364 646.795 795.038C605.937 811.06 563.45 775.821 522.989 758.819C494.129 746.692 471.026 727.403 444.877 710.193C416.565 691.557 381.798 681.669 362.961 653.49C341.807 621.845 331.196 583.169 334.621 545.259Z",
    fill: "#7E1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_263_49",
    x: 0.422424,
    y: 0.686096,
    width: 1125.7,
    height: 1131.99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 166.783,
    result: "effect1_foregroundBlur_263_49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedShadow);
export default __webpack_public_path__ + "static/media/red-shadow.364a3c5ac93bf75eebbea33b570742b8.svg";
export { ForwardRef as ReactComponent };